import { PAGE_CODES } from 'constants/pageCodes';
import { getConditionalArray } from 'utils/data';

export const COMPANY_TABS_ROUTING_PARAMS = {
  users: 'users',
  general: 'general',
  domains: 'domains',
  companyProperties: 'company-properties',
  emailSignature: 'email-signature',
  emailSnippets: 'email-snippets',
  emailDomains: 'email-domains',
  licensedStates: 'licensed-states',
  ppe: 'ppe',
  authentication: 'authentication',
  programsMapper: 'programs-mapper',
  businessDays: 'business-days',
  ausSettings: 'aus-settings',
  creditSettings: 'credit-settings',
  compensationCompliance: 'compensation-compliance',
  formFieldData: 'form-field-data',
  claimsConfiguration: 'claims-configuration',
  roleRestrictions: 'role-restrictions',
  phoneNumbers: 'phone-numbers',
  aiModels: 'ai-models',
  obConfig: 'ob-config',
  whitelist: 'whitelist',
  ipWhitelist: 'ip-whitelist',
  branding: 'branding',
  mobileApp: 'mobile-app',
};

// TODO: replace `internal` by actual claims
export const getTabsConfig = ({ isLicensingDisabled }) => [
  {
    label: 'General',
    route: COMPANY_TABS_ROUTING_PARAMS.general,
    pageCode: {
      default: PAGE_CODES.COMPANY,
      internal: PAGE_CODES.COMPANY,
    },
  },
  {
    label: 'Users',
    route: COMPANY_TABS_ROUTING_PARAMS.users,
    pageCode: {
      default: PAGE_CODES.USERS,
      internal: PAGE_CODES.INTERNAL_COMPANIES_USERS,
    },
  },
  {
    label: 'Domains',
    route: COMPANY_TABS_ROUTING_PARAMS.domains,
    pageCode: {
      default: PAGE_CODES.COMPANY_DOMAINS,
      internal: PAGE_CODES.INTERNAL_COMPANIES_DOMAINS,
    },
  },
  {
    label: 'Email Domains',
    route: COMPANY_TABS_ROUTING_PARAMS.emailDomains,
    pageCode: {
      default: PAGE_CODES.COMPANY_EMAIL_DOMAINS,
      internal: PAGE_CODES.INTERNAL_COMPANIES_EMAIL_DOMAINS,
    },
  },
  {
    label: 'Company Properties',
    route: COMPANY_TABS_ROUTING_PARAMS.companyProperties,
    pageCode: {
      default: PAGE_CODES.SYSTEM_PROPERTIES,
      internal: PAGE_CODES.INTERNAL_COMPANIES_SYSTEM_PROPERTIES,
    },
  },
  {
    label: 'Email Signature',
    route: COMPANY_TABS_ROUTING_PARAMS.emailSignature,
    pageCode: {
      default: PAGE_CODES.EMAIL_SIGNATURE_TEMPLATE,
      internal: PAGE_CODES.EMAIL_SIGNATURE_TEMPLATE,
    },
  },
  {
    label: 'Email Snippets',
    route: COMPANY_TABS_ROUTING_PARAMS.emailSnippets,
    pageCode: {
      default: PAGE_CODES.EMAIL_SNIPPETS_TEMPLATE,
      internal: PAGE_CODES.EMAIL_SNIPPETS_TEMPLATE,
    },
  },
  ...getConditionalArray(isLicensingDisabled !== 'true', [
    {
      label: 'Licensed States',
      route: COMPANY_TABS_ROUTING_PARAMS.licensedStates,
      pageCode: {
        default: PAGE_CODES.COMPANY_LICENSE_STATE,
        internal: PAGE_CODES.COMPANY_LICENSE_STATE,
      },
    },
  ]),
  {
    label: 'PPE',
    route: COMPANY_TABS_ROUTING_PARAMS.ppe,
    pageCode: {
      default: PAGE_CODES.PRICING_CONFIGURATION,
      internal: PAGE_CODES.PRICING_CONFIGURATION,
    },
  },
  {
    label: 'Authentication',
    route: COMPANY_TABS_ROUTING_PARAMS.authentication,
    pageCode: {
      default: PAGE_CODES.COMPANY_AUTH_METHOD,
      internal: PAGE_CODES.COMPANY_AUTH_METHOD,
    },
  },
  {
    label: 'Holidays/Business Days',
    route: COMPANY_TABS_ROUTING_PARAMS.businessDays,
    pageCode: {
      default: PAGE_CODES.COMPANY_BUSINESS_SCHEDULE,
      internal: PAGE_CODES.INTERNAL_COMPANY_BUSINESS_SCHEDULE,
    },
  },
  {
    label: 'AUS Settings',
    route: COMPANY_TABS_ROUTING_PARAMS.ausSettings,
    pageCode: {
      default: PAGE_CODES.COMPANY_AUS_SETTINGS,
      internal: PAGE_CODES.INTERNAL_COMPANY_AUS_SETTINGS,
    },
  },
  {
    label: 'Credit Settings',
    route: COMPANY_TABS_ROUTING_PARAMS.creditSettings,
    pageCode: {
      default: PAGE_CODES.SYSTEM_PROPERTIES,
      internal: PAGE_CODES.INTERNAL_COMPANIES_SYSTEM_PROPERTIES,
    },
  },
  {
    label: 'Compensation Compliance',
    route: COMPANY_TABS_ROUTING_PARAMS.compensationCompliance,
    pageCode: {
      default: PAGE_CODES.SUB_COMPANIES_COMPENSATION_PLANS,
      internal: PAGE_CODES.SUB_COMPANIES_COMPENSATION_PLANS,
    },
  },
  {
    label: 'Form Field Data',
    route: COMPANY_TABS_ROUTING_PARAMS.formFieldData,
    pageCode: {
      default: PAGE_CODES.COMPANY_FORM_FIELD_DATA,
      internal: PAGE_CODES.COMPANY_FORM_FIELD_DATA,
    },
  },
  {
    label: 'Claims Configuration',
    route: COMPANY_TABS_ROUTING_PARAMS.claimsConfiguration,
    pageCode: {
      default: PAGE_CODES.INTERNAL_COMPANIES_CLAIMS_CONFIGURATION,
      internal: PAGE_CODES.INTERNAL_COMPANIES_CLAIMS_CONFIGURATION,
    },
  },
  {
    label: 'Security Groups Configuration',
    route: COMPANY_TABS_ROUTING_PARAMS.roleRestrictions,
    pageCode: {
      default: PAGE_CODES.INTERNAL_COMPANIES_ROLE_CONFIGURATION,
      internal: PAGE_CODES.INTERNAL_COMPANIES_ROLE_CONFIGURATION,
    },
  },
  {
    label: 'Phone Numbers',
    route: COMPANY_TABS_ROUTING_PARAMS.phoneNumbers,
    pageCode: {
      default: PAGE_CODES.USERS_TELEPHONY,
      internal: PAGE_CODES.INTERNAL_COMPANY_USERS_TELEPHONY,
    },
  },
  {
    label: 'AI Models',
    route: COMPANY_TABS_ROUTING_PARAMS.aiModels,
    pageCode: {
      default: PAGE_CODES.AI_MODELS,
      internal: PAGE_CODES.AI_MODELS,
    },
  },
  {
    label: 'OB Config',
    route: COMPANY_TABS_ROUTING_PARAMS.obConfig,
    pageCode: {
      default: PAGE_CODES.INTERNAL_OB_CONFIGURATION,
      internal: PAGE_CODES.INTERNAL_OB_CONFIGURATION,
    },
  },
  {
    label: 'Whitelist',
    route: COMPANY_TABS_ROUTING_PARAMS.whitelist,
    pageCode: {
      default: PAGE_CODES.INTERNAL_COMPANY_WHITELIST,
      internal: PAGE_CODES.INTERNAL_COMPANY_WHITELIST,
    },
  },
  {
    label: 'IP Whitelist',
    route: COMPANY_TABS_ROUTING_PARAMS.ipWhitelist,
    pageCode: {
      default: PAGE_CODES.COMPANY_IP_WHITELIST,
      internal: PAGE_CODES.COMPANY_IP_WHITELIST,
    },
  },
  {
    label: 'Branding',
    route: COMPANY_TABS_ROUTING_PARAMS.branding,
    pageCode: {
      default: PAGE_CODES.COMPANY,
      internal: PAGE_CODES.COMPANY,
    },
  },
  {
    label: 'Mobile App',
    route: COMPANY_TABS_ROUTING_PARAMS.mobileApp,
    pageCode: {
      default: PAGE_CODES.COMPANY_MOBILE_APP_RELEASE,
      internal: PAGE_CODES.COMPANY_MOBILE_APP_RELEASE,
    },
  },
];
